// import components
import { Box } from '@mui/material';
import { StyledKbdBox, StyledKbdTypography } from './Kbd.styles';

// import from react
import { Fragment } from 'react';

// import types
import { KbdProps } from './Kbd.types';
import { keyIconMap } from './Kbd.consts';
import { Icon } from '@sdb/planning-ui';
import { IconContainer } from 'components/mrp/mrp.styles';

// utils
import { getPlatform } from './Kbd.utils';

const Kbd = ({ keys }: KbdProps) => {
  const normalizedKeys = keys.map((k) => k.toUpperCase());

  const os = getPlatform();
  const osSafeKeys = [
    ...(normalizedKeys.indexOf('PRIMARY') === -1
      ? []
      : [os === 'mac' ? '⌘' : 'Ctrl']),
    ...normalizedKeys.filter((key) => key !== 'PRIMARY')
  ];

  return (
    <StyledKbdBox>
      {osSafeKeys.map((key, index) => (
        <Fragment key={index}>
          {index > 0 && <Box component="span">+</Box>}
          <StyledKbdTypography component="kbd" variant="body2">
            {keyIconMap[key] ? (
              <IconContainer iconSize={'SMALL'}>
                <Icon type={keyIconMap[key]} />
              </IconContainer>
            ) : (
              key.toUpperCase()
            )}
          </StyledKbdTypography>
        </Fragment>
      ))}
    </StyledKbdBox>
  );
};

export default Kbd;
